import {config} from "./config";

export default class RootAddress{
    // Значения задаются в src/app/config.js (переменные REACT_APP_*).
    static getIStudyURLRest = config.istudyRestUrl;
    static getIStudyURL = config.istudyUrl;
    static getTestingSystemURL = config.testingUrl;
    static getMailingURL = config.mailingUrl;
}
